<div [ngClass]="{ 'has-error': isInvalid && isTouched && errorMessage }">
  <input
    #inputv2
    class="input-v2"
    [ngClass]="inputClassName"
    [ngStyle]="inputStyle"
    [(ngModel)]="value"
    (ngModelChange)="onInputChange()"
    (blur)="onBlur()"
    (wheel)="onWheel($event)"
    [currencyMask]="currencyMaskConfig"
    [options]="currencyMaskConfig"
    [disabled]="isDisabled"
    type="text"
    [placeholder]="placeholder"
    [attr.readOnly]="readonly ? 'readonly' : null"
    [attr.aria-invalid]="isInvalid ? 'true' : 'false'"
    [attr.aria-describedby]="isInvalid ? 'error-msg' : null"
    [attr.inputmode]="inputMode"
    (focus)="onFocus()"
    [maxlength]="maxLength()"
    [tabIndex]="tabIndex()"
  />

  <span
    *ngIf="isInvalid && isTouched"
    class="form-control-error-msg d-flex mt-2"
    [innerHTML]="errorMessage"
  ></span>
</div>
